<template>
  <div class="dashboard">
    <navComponent />
    <div class="container-fluid" style="width: 95%;">
      <div class="row">
        <div class="col-12 col-md-3 rounded">
          <div class="card">
            <sideBar :org_id="org_id" v-show="!isMobile"></sideBar>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="card">
            <div class="hidden-xs hidden-sm-up" v-if="isMobile">
              <sideBar class="container-fluid" v-show="organization && isMobile"></sideBar>
              <orgHome class="container-fluid" v-show="home && isMobile"></orgHome>
              <attendees class="container-fluid" v-show="attendees && isMobile"></attendees>
              <orgSettings class="container-fluid" v-show="orgSettings && isMobile"></orgSettings>
              <v-bottom-navigation
                v-show="isMobile"
                dark
                shift
                grow
                style="position:fixed;bottom: 0;height: auto;z-index: 16"
              >
                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showHome">
                  <span>Overview</span>
                  <v-icon>fas fa-home</v-icon>
                </v-btn>

                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showAttendee">
                  <span>Attendees</span>
                  <v-icon>fas fa-clipboard</v-icon>
                </v-btn>

                 <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showOrganization">
                  <span>Organization</span>
                  <v-icon>fas fa-sitemap</v-icon>
                </v-btn>

                <v-btn style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800" @click="showSettings">
                  <span>Settings</span>
                  <v-icon>fas fa-cog</v-icon>
                </v-btn>

              </v-bottom-navigation>
            </div>
            <div>
            <v-tabs
              background-color="deep-purple accent-4"
              class="elevation-2 d-none d-md-block"
              dark
              :grow="true"
              :icons-and-text="true"
            >
              <v-tabs-slider></v-tabs-slider>

              <v-tab key="overview" :href="`#overview`" style="color: #FFB229">
                OVERVIEW
                <v-icon color="#FFB229">fas fa-home</v-icon>
              </v-tab>
              <v-tab
                key="attendees"
                :href="`#attendees`"
                style="color: #FFB229"
              >
                ATTENDEES
                <v-icon color="#FFB229">fas fa-user</v-icon>
              </v-tab>
              <!-- <v-tab
                key="organization"
                :href="`#organization`"
                style="color: #FFB229"
              >
                ORGANIZATION
                <v-icon color="#FFB229">fas fa-sitemap</v-icon>
              </v-tab> -->
              <v-tab
                key="orgSettings"
                :href="`#orgSettings`"
                style="color: #FFB229"
              >
                SETTINGS
                <v-icon color="#FFB229">fas fa-cog</v-icon>
              </v-tab>

              <v-tab-item key="overview" value="overview">
                <v-card flat tile style="background: #000;color: #fff">
                  <orgHome class="container-fluid"></orgHome>
                </v-card>
              </v-tab-item>
              <v-tab-item key="attendees" value="attendees">
                <v-card flat tile style="background: #000;color: #fff">
                  <attendees class="container-fluid"></attendees>
                </v-card>
              </v-tab-item>
              <!-- <v-tab-item key="organization" value="organization">
                <v-card flat tile style="background: #000;color: #fff">
                  <sideBar class="container-fluid"></sideBar>
                </v-card>
              </v-tab-item> -->
              <v-tab-item key="orgSettings" value="orgSettings">
                <v-card flat tile style="background: #000;color: #fff">
                  <orgSettings class="container-fluid"></orgSettings>
                </v-card>
              </v-tab-item>
            </v-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navComponent from "@/components/dashboard/nav.vue";
import sideBar from "@/components/dashboard/side-bar.vue";
import orgHome from "@/components/dashboard/org-home.vue";
import attendees from "@/components/dashboard/attendees.vue";
import orgSettings from "@/components/dashboard/organization-settings.vue";
export default {
  name: "dashboard",
  props: {
    id: String,
  },
  data() {
    return {
      user: { is_admin: false },
      upcomingEvents: [],
      teams: [],
      events: [],
      registered_user_count: 0,
      org_id: "",
      home: true,
      attendees: false,
      orgSettings: false,
      organization: false,
      windowWidth: window.innerWidth,
    };
  },
  components: {
    navComponent,
    sideBar,
    orgHome,
    attendees,
    orgSettings
  },
  created() {
    this.user = JSON.parse(localStorage.getItem("user_info"));
    if (this.user === null) {
      this.$router.push("/");
    }
    if (!this.id) {
      this.org_id = this.$router.query("id");
      this.$router.push("/dashboard");
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    },
  },
  methods: {
    showHome() {
      this.home = true;
      this.attendees = false;
      this.orgSettings = false;
      this.organization = false;
    },
    showAttendee() {
      this.home = false;
      this.attendees = true;
      this.orgSettings = false;
      this.organization = false;
    },
    showSettings() {
      this.home = false;
      this.attendees = false;
      this.orgSettings = true;
      this.organization = false;
    },
    showOrganization() {
      this.home = false;
      this.attendees = false;
      this.orgSettings = false;
      this.organization = true;
    }
  },
};
</script>

<style scoped>
</style>
